require("angular");
require("select2"); 
require("ng-modules/ui-select-0.8.3/select.min.js");
require("ng-modules/ui-select-0.8.3/select.min.css");


/** WEBPACK FOOTER **
 ** ./app_components/ng-ui-select/index.js
 **/